import styled, { css } from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";

export const StyledTextareaWrapper = styled.div`
    display: block;
    position: relative;
    max-width: 604px;
`;

export const StyledResizer = styled.div`
    position: absolute;
    width: 8px;
    height: 8px;
    bottom: 2px;
    right: 2px;
    pointer-events: none;
    display: flex;
`;

export const StyledTextarea = styled.textarea<{ disabled: boolean; width: number }>`
    border: 1px solid ${colorsPalettes.midnight[50]};
    padding: 8px;
    height: 64px;
    min-height: 64px;
    width: ${({ width }) => `${width}px`};
    max-width: ${({ width }) => `${width}px`};
    min-width: ${({ width }) => `${width}px`};
    ${setFontVariant("input2", colorsPalettes.carbon[400])}
    margin: 0;
    box-shadow: none;
    border-radius: 3px;
    &::placeholder {
        color: ${colorsPalettes.carbon[200]};
    }
    &:focus {
        outline: none;
        box-shadow: 0 3px 5px 0 ${rgba(colorsPalettes.carbon[500], 0.12)};
        border: 1px solid ${colorsPalettes.midnight[50]};
    }
    &::-webkit-scrollbar {
        width: 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${colorsPalettes.carbon[200]};
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: ${colorsPalettes.carbon[0]};
    }
    &::-webkit-resizer {
        display: none;
    }

    ${({ disabled }) =>
        disabled &&
        css`
            background-color: ${colorsPalettes.bluegrey[200]} !important;
            color: ${colorsPalettes.midnight[100]} !important;
            cursor: not-allowed !important;
            &::-webkit-scrollbar-track {
                border-radius: 10px;
                background: ${colorsPalettes.bluegrey[200]};
            }
        `}
`;
